export const significantDigits = (amount: number, digits: number = 4) => {
    let insignificantDigits = amount.toString().search(/[1-9]/) - 2; // exclude first 0 and the floating point.
    let precision = Math.max(0, insignificantDigits) + digits;
    return Number(amount).toFixed(precision);
}
